// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"oh","content":"oi","navigation":"oj","mainPanel":"ok","footer":"ol"};